"use client";

import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { IconHeading } from "./IconHeading";

type PageHeroProps = {
  eyebrow?: ReactNode;
  title: ReactNode;
  text?: ReactNode;
  actions?: ReactNode;
  note?: ReactNode;
  visual?: ReactNode;
  className?: string;
  contentClassName?: string;
};

export const PageHero = ({
  eyebrow,
  title,
  text,
  actions,
  note,
  visual,
  className,
  contentClassName,
}: PageHeroProps) => (
  <section className={cn("page-hero", className)}>
    <div
      className={cn(
        "page-hero-grid",
        !visual && "lg:grid-cols-1",
        contentClassName,
      )}
    >
      <div
        className={cn(
          "page-hero-copy",
          !visual && "mx-auto max-w-3xl text-center lg:items-center",
        )}
      >
        {eyebrow && <div className="eyebrow">{eyebrow}</div>}
        <h1 className="display-1">{title}</h1>
        {text && <div className="lede max-w-2xl">{text}</div>}
        {actions && (
          <div
            className={cn("page-edge-actions", !visual && "sm:justify-center")}
          >
            {actions}
          </div>
        )}
        {note && <div className="body-text max-w-2xl">{note}</div>}
      </div>
      {visual && <div className="page-hero-visual">{visual}</div>}
    </div>
  </section>
);

type PageCtaProps = {
  eyebrow?: ReactNode;
  icon?: ReactNode;
  title: ReactNode;
  text?: ReactNode;
  actions?: ReactNode;
  visual?: ReactNode;
  note?: ReactNode;
  className?: string;
};

export const PageCta = ({
  eyebrow,
  icon,
  title,
  text,
  actions,
  visual,
  note,
  className,
}: PageCtaProps) => (
  <div className={cn("page-cta", className)}>
    {visual && <div className="page-cta-visual">{visual}</div>}
    <div
      className={cn(
        "page-cta-copy",
        !visual && "mx-auto max-w-3xl text-center lg:items-center",
      )}
    >
      {eyebrow && <div className="eyebrow">{eyebrow}</div>}
      {icon ? (
        <IconHeading as="h2" icon={icon} className="display-2">
          {title}
        </IconHeading>
      ) : (
        <h2 className="display-2">{title}</h2>
      )}
      {text && <div className="lede max-w-2xl">{text}</div>}
      {actions && (
        <div
          className={cn("page-edge-actions", !visual && "sm:justify-center")}
        >
          {actions}
        </div>
      )}
      {note && <div className="body-text max-w-2xl">{note}</div>}
    </div>
  </div>
);
